/**
 * 予約中の本の受取状態バッジ (受取可 / 受取期限切れ / 受取済み)
 *
 * 図書館検索の予約中一覧と、インポート画面の予約中一覧で使う。
 */

import { CircleAlert, HandHelping, PackageCheck } from 'lucide-react'

import type { LibraryFavorite } from '@/api/types/library-favorite'
import { formatPickupDate } from '@/lib/library-pickup'
import { cn } from '@/lib/utils'

type Props = {
  favorite: Pick<LibraryFavorite, 'pickup_state' | 'pickup_deadline' | 'pickup_branch'>
  className?: string
}

const BASE = 'inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium'

export const LibraryPickupBadge = ({ favorite, className }: Props) => {
  const deadline = favorite.pickup_deadline ? formatPickupDate(favorite.pickup_deadline) : null
  switch (favorite.pickup_state) {
    case 'ready':
      return (
        <span className={cn(BASE, 'border-amber-400/60 bg-amber-400/15 text-amber-300', className)}>
          <HandHelping className="size-3" />
          受取可{deadline && `・${deadline}まで`}
          {favorite.pickup_branch && `・${favorite.pickup_branch}`}
        </span>
      )
    case 'expired':
      return (
        <span className={cn(BASE, 'border-red-500/50 bg-red-500/10 text-red-400', className)}>
          <CircleAlert className="size-3" />
          受取期限切れ{deadline && `（${deadline}）`}
        </span>
      )
    case 'picked_up':
      return (
        <span className={cn(BASE, 'border-sky-400/50 bg-sky-400/10 text-sky-300', className)}>
          <PackageCheck className="size-3" />
          受取済み
        </span>
      )
    default:
      return null
  }
}
